export const getApiUrl = () => {
  if (window.location.hostname.toLowerCase().startsWith("localhost"))
    return "https://devdashboardapi.enrichmycare.com/api";
    //return "https://localhost:44371/api";
  else if (window.location.hostname.toLowerCase().startsWith("devreferral.enrichmycare.com"))
    return "https://devdashboardapi.enrichmycare.com/api";
  else if (window.location.hostname.toLowerCase().startsWith("qareferral.enrichmycare.com"))
    return "https://qadashboardapi.enrichmycare.com/api";
  else if (window.location.hostname.toLowerCase().startsWith("referral.enrichmycare.com"))
    return "https://dashboardapi.enrichmycare.com/api";
  else
    return "";
}